import { Navigate, useOutletContext } from "react-router-dom"
import type { LayoutOutletContext } from "~/components/Layout"

export function RootRedirect() {
  const { profile, authLoading } = useOutletContext<LayoutOutletContext>() ?? {
    profile: null,
    authLoading: true,
  }

  if (authLoading) {
    return null
  }

  return <Navigate to={profile ? "/dashboard" : "/assessment"} replace />
}
